import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { mergeMap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private httpClient: HttpClient) { }

  getTranslation(lang: string) {
    return this.httpClient.get(`${environment.apiBaseUrl}/api/translation/version`, { responseType: 'text' }).pipe(
      mergeMap(version => this.httpClient.get(`${environment.apiBaseUrl}/api/translation/${lang}.json?version=${version}`))
    );
  }
}
